import Button from '@mui/material/Button'
import DialogContentText from '@mui/material/DialogContentText'
import ListItem from '@mui/material/ListItem'
import Stack from '@mui/material/Stack'
import { useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import useMediaQuery from '@mui/material/useMediaQuery'
import { KNBulletList } from 'components/KNBulletList/KNBulletList'
import KNDialog from 'components/KNDialog/KNDialog'
import { type ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

export interface ConfidentialReportingLineDialogProps {
  open: boolean
  onAction: () => void
  onClose: () => void
}

const ConfidentialReportingLineDialog = ({
  open,
  onAction,
  onClose,
}: ConfidentialReportingLineDialogProps): ReactNode => {
  const { t } = useTranslation()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <KNDialog
      open={open}
      onClose={onClose}
      title={isMobile ? t('footer.confidential_reporting_line.drivers.header') : t('footer.confidential_reporting_line.operators.header')}
      actions={
        <Button
          color="secondary"
          variant="contained"
          onClick={onAction}
        >
          {t('footer.confidential_reporting_line.action')}
        </Button>
      }
    >
      <DialogContentText>
        {isMobile ? (
          <Stack spacing={1}>
            <Typography color="text.main">{t('footer.confidential_reporting_line.drivers.intro')}</Typography>
            <KNBulletList sx={{ color: 'text.main' }}>
              <ListItem>{t('footer.confidential_reporting_line.drivers.bullet_1')}</ListItem>
              <ListItem>{t('footer.confidential_reporting_line.drivers.bullet_2')}</ListItem>
              <ListItem>{t('footer.confidential_reporting_line.drivers.bullet_3')}</ListItem>
              <ListItem>{t('footer.confidential_reporting_line.drivers.bullet_4')}</ListItem>
              <ListItem>{t('footer.confidential_reporting_line.drivers.bullet_5')}</ListItem>
              <ListItem>{t('footer.confidential_reporting_line.drivers.bullet_6')}</ListItem>
            </KNBulletList>
            <Typography color="text.main">{t('footer.confidential_reporting_line.drivers.outro')}</Typography>
          </Stack>
        ) : (
          <Stack spacing={1}>
            <Typography color="text.main">{t('footer.confidential_reporting_line.operators.intro')}</Typography>
            <KNBulletList sx={{ color: 'text.main' }}>
              <ListItem>{t('footer.confidential_reporting_line.operators.bullet_1')}</ListItem>
              <ListItem>{t('footer.confidential_reporting_line.operators.bullet_2')}</ListItem>
              <ListItem>{t('footer.confidential_reporting_line.operators.bullet_3')}</ListItem>
              <ListItem>{t('footer.confidential_reporting_line.operators.bullet_4')}</ListItem>
              <ListItem>{t('footer.confidential_reporting_line.operators.bullet_5')}</ListItem>
              <ListItem>{t('footer.confidential_reporting_line.operators.bullet_6')}</ListItem>
              <ListItem>{t('footer.confidential_reporting_line.operators.bullet_7')}</ListItem>
              <ListItem>{t('footer.confidential_reporting_line.operators.bullet_8')}</ListItem>
            </KNBulletList>
            <Typography color="text.main">{t('footer.confidential_reporting_line.operators.outro')}</Typography>
          </Stack>
        )}
      </DialogContentText>
    </KNDialog>
  )
}

export default ConfidentialReportingLineDialog
